import { createSlice } from "@reduxjs/toolkit";
import { normalizeOrderType } from "@/lib/orderType";

const initialState = {
  cartDrawer: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openCartDrawer(state, action) {
      state.cartDrawer = normalizeOrderType(action.payload);
    },
    closeCartDrawer(state) {
      state.cartDrawer = null;
    },
  },
});

export const { openCartDrawer, closeCartDrawer } = uiSlice.actions;
export default uiSlice.reducer;
